/**
 * A lightweight confetti burst. Renders a fixed number of paper-ish pieces
 * that fall and rotate using the .confetti animation in globals.css.
 * Mount it conditionally (e.g. on a correct answer) and unmount after ~3s.
 */
const COLORS = ['#2e348d', '#329f81', '#b00378', '#f6c945', '#ffffff'];
const PIECES = 28;

export function ConfettiBurst() {
  return (
    <div className="pointer-events-none fixed inset-0 z-50 overflow-hidden" aria-hidden="true">
      {Array.from({ length: PIECES }).map((_, i) => {
        // Deterministic-ish spread without Math.random dependency concerns.
        const left = (i / PIECES) * 100;
        const delay = (i % 7) * 0.12;
        const duration = 2.4 + (i % 5) * 0.3;
        const size = 7 + (i % 4) * 3;
        const color = COLORS[i % COLORS.length];
        return (
          <span
            key={i}
            className="confetti absolute top-0 rounded-sm"
            style={{
              left: `${left}%`,
              width: size,
              height: size * 1.4,
              backgroundColor: color,
              animationDelay: `${delay}s`,
              animationDuration: `${duration}s`,
            }}
          />
        );
      })}
    </div>
  );
}
